import { NetworkStatus } from '@apollo/client';
import { Box, Spinner, SpinnerSize, Text } from '@bechtel/gds';
import { useEffect } from 'react';
import { ErrorRetry } from '~/components/atoms/error-retry';
import { useAuthorizeUser } from '~/hooks/use-authorize-user';
import { ForbiddenAccess } from '../forbidden-access';
import { NotAuthorizedContainer } from './styled';

export const AuthRoute = ({ children }) => {
  const [getUserAccountByAuth, { loading, error, data, refetch, networkStatus, called }] = useAuthorizeUser();
  useEffect(() => {
    if (called) return;
    getUserAccountByAuth();
  });

  if (loading || networkStatus === NetworkStatus.refetch) {
    return (
      <Box
        alignItems={{ sm: 'center' }}
        justifyContent={{ sm: 'center' }}
        flexGrow={{ sm: 1 }}
        flexDirection={{ sm: 'column' }}
        p={{ sm: '500' }}
        data-testid="loading"
      >
        <Spinner size={SpinnerSize.LARGE}></Spinner>
        <Text color="blue.800" size="600">
          Authorizing
        </Text>
      </Box>
    );
  }

  if (!loading && error)
    return (
      <Box>
        <ErrorRetry refetch={refetch} />
      </Box>
    );

  if ((!data && called) || (data && !data.userByAuth.isActive))
    return (
      <NotAuthorizedContainer>
        <ForbiddenAccess />
      </NotAuthorizedContainer>
    );
  return called && children;
};
